import { render, staticRenderFns } from "./FormImagemBannerComponent.vue?vue&type=template&id=5dc5683a&scoped=true"
import script from "./FormImagemBannerComponent.vue?vue&type=script&lang=js"
export * from "./FormImagemBannerComponent.vue?vue&type=script&lang=js"
import style0 from "./FormImagemBannerComponent.vue?vue&type=style&index=0&id=5dc5683a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc5683a",
  null
  
)

export default component.exports